export default "__VITE_ASSET__ed2d4e17__"